<template>
  <button
    class="dataset-tag-row"
    type="button"
    aria-label="Manage Tags and Versions"
    @click="openHistoryPage"
  >
    <template v-if="hasTag">
      <span class="dataset-tag-row__label">Tag:</span>
      <span v-tooltip:center.top="'Manage Tags and Versions'" class="dataset-tag-row__tag">{{ tad }}</span>
      <span class="dataset-tag-row__description">{{ tag_description }}</span>
    </template>
    <template v-else>
      <span v-tooltip:center.top="'Manage Tags and Versions'" class="dataset-tag-row__warning">
        Tag does not exist
      </span>
    </template>
  </button>
</template>

<script setup>
import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';

const props = defineProps({
  tad: {
    type: String,
    default: '',
  },
  tag_description: {
    type: String,
    default: '',
  },
  dataset_id: {
    type: [String, Number],
    default: '',
  },
});

const router = useRouter();
const route = useRoute();

const hasTag = computed(() => Boolean((props.tad || '').trim()));

function openHistoryPage() {
  const datasetId = props.dataset_id || route.params.id || route.params.datasetId;

  if (datasetId) {
    router.push({ name: 'dataset.history', params: { id: datasetId } });
    return;
  }

  router.push({ name: 'datasets' });
}
</script>

<style scoped lang="scss">
.dataset-tag-row {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  font-size: 0.75rem;
  border: none;
  background: transparent;
  cursor: pointer;
  padding: 0;
  text-align: left;

  &:hover {
    opacity: 0.8;
  }

  &__label {
    font-weight: 400;
    @include themify() {
      color: themed('body-text-color-secondary');
    }
  }

  &__tag {
    font-weight: 400;
    @include themify() {
      color: themed('body-text-color');
    }
  }

  &__description {
    @include themify() {
      color: themed('body-text-color-secondary');
    }
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &__warning {
    color: #d32f2f;
    font-weight: 600;
    cursor: pointer;
  }
}
</style>
